import { render, staticRenderFns } from "./DevTestRandomPlayers.vue?vue&type=template&id=4ed780ee&"
import script from "./DevTestRandomPlayers.vue?vue&type=script&lang=js&"
export * from "./DevTestRandomPlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports